<template>
  <div class="shop-page">
    <top-bar :topbarList="shopsTopBarList"></top-bar>
    <router-view></router-view>
  </div>
</template>

<script>
import topBar from "@/components/topBar.vue";

import { shopsIndexMixins } from "@/mixins/shopsIndexMixins";

export default {
  mixins: [shopsIndexMixins],
  data() {
    return {};
  },
  computed: {},
  components: {
    topBar,
  },
};
</script>

<style lang="less" scoped>
.shop-page {
  height: 100%;
}
</style>
